const displayVersion = (instance) => {
  console.log(instance.input.version);
};

export { displayVersion };
